import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";

// Fetch
import { getAllUser } from "@/fetch/fetchStaff";

// Config
import { StaffTableColumn } from "@/config/tableColumnConfig";
import { useCurrentAction } from "@/hooks/user";

const StaffManagePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();

  // States
  const [staffData, setStaffData] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onClickCreate = () => {
    navigate("create");
  };

  const onCellClick = (data) => {
    if (data.field === "__check__") return;
    else navigate(`edit/${data.id}`);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getAllUser().then((data) => {
        if (data && data.results) {
          let tempArr = [...data.data];
          for (let i = 0; i < tempArr.length; i++) {
            delete tempArr[i].shop_permission;
          }
          setStaffData(tempArr);
        }
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      selectedIndex={5}
      open={open}
      setOpen={setOpen}
    >
      <Title
        FunctionOn={actions?.create}
        title="管理員工"
        createName="新增員工"
        onClickCreate={() => onClickCreate()}
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={staffData}
            columns={StaffTableColumn}
            onCellClick={(params) => onCellClick(params)}
            checkboxSelection={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "staff_code", sort: "asc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default StaffManagePage;
